// ** React Imports
import { Fragment } from 'react';

// ** Third Party Components
import Flatpickr from 'react-flatpickr';
import '@styles/react/libs/charts/apex-charts.scss';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import moment from 'moment';

const PickerRange = ({ onChange, value }) => {
  // ** State
  return (
    <Fragment>
      <Flatpickr
        value={value}
        id="range-picker"
        className="form-control"
        onChange={(date) => onChange(date)}
        options={{
          mode: 'range',
          locale: Spanish,
          defaultDate: [
            moment().subtract(30, 'days').toDate(),
            moment().toDate()
          ]
        }}
      />
    </Fragment>
  );
};

export default PickerRange;
